import { type EntityATI } from '@atlassian/search-client/common/types';

import { type TypeFilterValueKey as TypeFilterValueKeyType } from '../../../../../common/constants/filters/universal-type';
import { type ProductKeys } from '../../../../../common/constants/product-keys';
import { notRequestedATIsInAllSearch } from '../../../../../common/utils/filters/constants';
import { isAllProductSearch } from '../../../../../common/utils/is-all-product-search';

export const isEntityEnabled: (
	ati: EntityATI,
	selectedTypes: TypeFilterValueKeyType[],
	selectedProducts: ProductKeys[] | undefined,
) => boolean = (
	ati: EntityATI,
	selectedTypes: TypeFilterValueKeyType[],
	selectedProducts: ProductKeys[] | undefined,
): boolean => {
	// In the "all products" and "all types" search, we drop some entities for relevance
	// If types are selected (e.g. "All products" + "Page") or a product is selected ("Confluence" + "all types"), we don't drop any entities
	if (selectedTypes.length === 0 && selectedProducts && isAllProductSearch(selectedProducts)) {
		return !notRequestedATIsInAllSearch().includes(ati);
	}
	return true;
};
